import { apiService } from './api'
import type { Activity, CreateActivityData, PaginationParams, PaginatedResponse } from '@/types'

class ActivityService {
  async getActivities(params?: PaginationParams): Promise<PaginatedResponse<Activity>> {
    const response = await apiService.api.get('/admin/activities', { params })
    return response.data
  }

  async getAllActivities(): Promise<{ data: Activity[] }> {
    const response = await apiService.api.get('/admin/activities/all')
    return response.data
  }

  async getRecentActivities(limit: number = 10): Promise<{ data: Activity[] }> {
    const response = await apiService.api.get(`/admin/activities/recent?limit=${limit}`)
    return response.data
  }

  async getUnreadActivities(): Promise<{ data: Activity[], count: number }> {
    const response = await apiService.api.get('/admin/activities/unread')
    return response.data
  }

  async createActivity(data: CreateActivityData) {
    const response = await apiService.api.post('/admin/activities', data)
    return response.data
  }

  async markAsRead(id: number): Promise<void> {
    await apiService.api.patch(`/admin/activities/${id}/read`)
  }

  async markAllAsRead(): Promise<void> {
    await apiService.api.patch('/admin/activities/read-all')
  }

  async deleteActivity(id: number): Promise<void> {
    await apiService.api.delete(`/admin/activities/${id}`)
  }

  async getActivityStats(): Promise<{
    total: number
    unread: number
    today: number
  }> {
    const response = await apiService.api.get('/admin/activities/stats')
    return response.data.data
  }
}

export const activityService = new ActivityService()